import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { LoadStatus } from '@capital-access/common/utils';
import { SimpleActionableEmptyStatesOptions } from '@capital-access/firefly/components';
import {
  EXPORT_REPORT_ITINERARY_ACTIVITIES,
  EXPORT_REPORT_ITINERARY_EVENT,
  MAX_TEMPLATES_PER_ACCOUNT,
  ReportTemplate,
  ReportTemplateFormType,
  ReportType,
  TemplateLibraryService
} from '@capital-access/reporting/common';
import {
  loadAllTemplates,
  NavigationIntentService,
  openCreateReportingTemplateDrawer
} from '@capital-access/reporting/template-library';
import { LOCALIZATION_KEY } from '../../../constants';
import { ItineraryTemplatesStore } from '../../services/templates.store';

@Component({
  selector: 'ca-configurable-itinerary-templates',
  templateUrl: './configurable-itinerary-templates.component.html',
  styleUrls: ['./configurable-itinerary-templates.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ConfigurableItineraryTemplatesComponent implements OnInit {
  @Input() request?: any;
  @Input() setAsDefaultControl!: FormControl;
  private totalTemplateCount = 0;
  private isDisabled = false;
  readonly templatesStore = inject(ItineraryTemplatesStore);
  private readonly templateLibraryService = inject(TemplateLibraryService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  readonly LoadStatus = LoadStatus;
  readonly MAX_TEMPLATES_PER_ACCOUNT = MAX_TEMPLATES_PER_ACCOUNT;
  readonly localizationScope = LOCALIZATION_KEY;
  readonly SimpleActionableEmptyStatesOptions = SimpleActionableEmptyStatesOptions;
  readonly store = inject(Store);
  readonly navigationIntent = inject(NavigationIntentService) as NavigationIntentService;

  createTemplate() {
    if (this.request?.activities?.length) {
      localStorage.removeItem(EXPORT_REPORT_ITINERARY_EVENT);
      localStorage.setItem(EXPORT_REPORT_ITINERARY_ACTIVITIES, JSON.stringify(this.request.activities));
    } else {
      localStorage.removeItem(EXPORT_REPORT_ITINERARY_ACTIVITIES);
      const event = {
        eventId: this.request?.eventId,
        name: this.request?.eventName,
        startDate: this.request?.startDate,
        endDate: this.request?.endDate,
        type: this.request?.eventType
      };
      localStorage.setItem(EXPORT_REPORT_ITINERARY_EVENT, JSON.stringify(event));
    }
    this.navigationIntent.setOpenInNewTab(true);
    this.store.dispatch(loadAllTemplates({ silentRefresh: false }));
    this.store.dispatch(
      openCreateReportingTemplateDrawer({
        reportType: ReportType.Itinerary,
        actionType: ReportTemplateFormType.create
      })
    );
  }

  onTemplateSelected(template: ReportTemplate): void {
    this.templatesStore.setSelectedTemplate(template);
    this.setAsDefaultControl.setValue(false, { emitEvent: false });
  }

  ngOnInit() {
    this.templateLibraryService.getTemplates().subscribe((templates: ReportTemplate[]) => {
      const teamTemplates = templates.filter((t: ReportTemplate) => !t.caTemplateInd);
      this.totalTemplateCount = teamTemplates.length;

      this.isDisabled = this.totalTemplateCount >= MAX_TEMPLATES_PER_ACCOUNT;

      this.changeDetectorRef.markForCheck();
    });
  }

  get isCreateTemplateDisabled() {
    return this.templatesStore.myTeamTemplateCount() >= MAX_TEMPLATES_PER_ACCOUNT || this.isDisabled;
  }
}
